import { SDK } from '@redge-media/fo-js-sdk';
import { HeaderName } from '@/shared/enums';
import { generateCookie } from './bookmark-cookie';

export default {
  remove(record, opts = {}) {
    const method = 'del';
    const sync = () => {
      this.collection.remove(record.id);
      return this.emit('sync', method, record);
    };

    if (!opts.sync) {
      return Promise.resolve(sync());
    }

    return SDK.apiAdapter[method](this.endpoint, {
      headers: {
        [HeaderName.STATS_HASH]: this.subscriber.externalStatsHash,
      },
      params: {
        itemId: [record.id],
        token: this.subscriber.profile.token,
        profileId: this.subscriber.profile.id,
      },
    }).then(() => {
      generateCookie({
        id: this.subscriber.id,
        name: this.cookieName,
        time: this.time.now,
      });

      if (!opts.refresh) {
        return Promise.resolve(sync());
      }

      return this.fetchAll('', { reset: true });
    });
  },
};
